import { api } from '..'

export const exportLoginHistoryToCsv = async (
  params?: Record<string, string>,
) => {
  const response = await api.get('v1/login-history/export-csv', {
    responseType: 'blob',
    params,
  })
  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-')
  link.setAttribute('download', `login-history-${timestamp}.csv`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
